import { useTranslation } from 'react-i18next'

import { IconViewers } from 'assets/svg/sprite'
import './_liveStats.scss'

interface LiveStatsProps {
  type: 'viewers' | 'goal'
  clickFn?: () => void
  count?: number

  // viewers/live props
  showTips?: boolean
  tipsAmount?: number

  // goal props
  goalTipped?: number
  goalTotal?: number | null
}

const LiveStats = ({
  type,
  clickFn,
  count,
  showTips = false,
  tipsAmount = 0,
  goalTipped,
  goalTotal,
}: LiveStatsProps) => {
  const { t } = useTranslation()
  const nf = new Intl.NumberFormat()

  const dollars = (n: number | null | undefined) =>
    n == null ? '—' : `$${nf.format(Math.max(0, Number(n) || 0))}`

  return (
    <div className={`livestats ${type}`}>
      <div className='livestats__left'>
        <span>{type === 'viewers' ? t('live') : t('goal')}</span>
      </div>

      <div className='livestats__right' onClick={clickFn}>
        {type === 'viewers' && (
          <>
            <IconViewers />
            <span>{nf.format(count ?? 0)}</span>

            {showTips && (
              <>
                <span className='livestats__pipe'>|</span>
                <span>{dollars(tipsAmount)}</span>
              </>
            )}
          </>
        )}

        {type === 'goal' && (
          <div className='goal-content'>
            <span>{dollars(goalTipped)}</span>
            <span>/</span>
            <span>{dollars(goalTotal ?? null)}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default LiveStats